import React from 'react'
import { withTranslation } from 'react-i18next'

import CheckSquare from 'app/components/SVGS/CheckSquare'
import Done from 'app/components/SVGS/Done'

import './styles.scss'

const bc = 'company-dashboard-commits'

const CompanyDashboardCommits = ({ t, commits }) => {
  if (!commits) {
    return null
  }
  return (
    <div className={bc}>
      <div className={`${bc}__title`}>{t('Commits')}</div>

      <div className={`${bc}__commits-section`}>
        <div className={`${bc}__commits-icon`}>
          <Done />
        </div>
        <div className={`${bc}__commits-info`}>
          <div className={`${bc}__commits-info-number`}>{parseInt(commits.total).toLocaleString()}</div>
          <div className={`${bc}__commits-info-title`}>{t('Total')}</div>
        </div>
      </div>

      <div className={`${bc}__commits-section`}>
        <div className={`${bc}__commits-icon`}>
          <CheckSquare />
        </div>
        <div className={`${bc}__commits-info`}>
          <div className={`${bc}__commits-info-number`}>{commits.past24Hrs}</div>
          <div className={`${bc}__commits-info-title`}>{t('Past 24 Hrs')}</div>
        </div>
      </div>
    </div>
  )
}

CompanyDashboardCommits.displayName = 'CompanyDashboardCommits'

export default withTranslation('user')(CompanyDashboardCommits)
